import axios from "axios";
import { API } from "../config";

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";

// Chamadas do bootstrap de login (logo após o redirect do SSO) podem falhar na
// primeira tentativa por causa de instrumentação de RUM (Dynatrace OneAgent) do
// ambiente, que faz patch de fetch/XHR nesse mesmo instante. Retry cobre o sintoma.
const RETRY_DELAYS_MS = [400, 800];

const withRetry = async (requestFn) => {
  for (const delayMs of RETRY_DELAYS_MS) {
    try {
      return await requestFn();
    } catch (err) {
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }
  return requestFn();
};

class PerfilAcessoService {
  novoPerfilAcesso(perfilAcesso) {
    return axios.post(API + "/perfil-acesso", perfilAcesso);
  }

  listarPerfilAcesso() {
    return axios.get(API + "/perfil-acesso");
  }

  getPerfilAcesso(id) {
    return axios.get(API + "/perfil-acesso/" + id);
  }

  atualizarPerfilAcesso(id, perfilAcesso) {
    return axios.put(API + "/perfil-acesso/" + id, perfilAcesso);
  }

  inativarPerfilAcesso(id, perfilAcesso) {
    return axios.put(API + "/perfil-acesso/" + id + "/inativar", perfilAcesso);
  }

  reativarPerfilAcesso(id, perfilAcesso) {
    return axios.put(API + "/perfil-acesso/" + id + "/reativar", perfilAcesso);
  }

  pesquisarPerfilAcesso(descricao, status, tipoOrgaoId) {
    return axios.get(API + "/perfil-acesso/search", {
      params: {
        descricao: descricao !== "" ? descricao : undefined,
        status: status !== "" ? status : undefined,
        tipoOrgaoId: tipoOrgaoId !== "" ? tipoOrgaoId : undefined,
      },
    });
  }

  listarTiposOrgao() {
    return axios.get(API + "/perfil-acesso/tipos-orgao/vinculados");
  }

  listarOrgaosExternosVinculados(ids) {
    const params = new URLSearchParams();
    ids.forEach((id) => params.append("orgaoExternos", id));
    return withRetry(() =>
      axios.get(
        API +
          "/perfil-acesso/tipos-orgao-externo/vinculados?" +
          params.toString(),
      ),
    );
  }

  listarPromotoriasVinculadas() {
    return axios.get(API + "/perfil-acesso/orgaos/vinculados");
  }

  verificarPerfilOrgao(perfis, tipoOrgaos) {
    const params = new URLSearchParams();
    perfis.forEach((p) => params.append("perfis", p));
    const orgaosToSend = tipoOrgaos.length > 0 ? tipoOrgaos : [0];
    orgaosToSend.forEach((t) => params.append("tipoOrgaos", t));
    return withRetry(() =>
      axios.post(
        API +
          "/perfil-acesso/tipos-orgao-externo/verificacao-perfil?" +
          params.toString(),
      ),
    );
  }

  verificarCompatibilidade(idPerfilSelecionado, idTipoOrgao) {
    const params = new URLSearchParams();
    params.append("id_perfil_selecionado", idPerfilSelecionado);
    params.append("idTipoOrgao", idTipoOrgao ?? 0);
    return withRetry(() =>
      axios.post(
        API +
          "/perfil-acesso/tipos-orgao-externo/verificacao-compatibilidade?" +
          params.toString(),
      ),
    );
  }
}

const instancePerfilAcesso = new PerfilAcessoService();
export default instancePerfilAcesso;
